import debounce from 'lodash/debounce';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { useMemo, useState } from 'react';
import { useGetQBooksCustomersRaw } from 'shared/data/webApp/v1';

import { mapQBooksContacts } from '../../../data/qbooks/QBooksContact';
import { getContext, getRequest } from '../../../selectors/pageSelectors';
import { requestSelector } from '../../../selectors/pageSelectors';
import { getRequestEditMode } from '../../../selectors/requestSelectors';
import { getRuleTypeByEditMode } from '../../../utils/helpers';

export const useShipToItems = () => {
    const [query, setQuery] = useState('');
    const request = useSelector(requestSelector);
    const editMode = useSelector((state) => getRequestEditMode(state, request));
    const ruleType = getRuleTypeByEditMode(editMode);

    const { data, isLoading } = useGetQBooksCustomersRaw({
        query: {
            requestId: request.id,
            companyId: request.companyId,
            query,
            startFrom: 0,
            rowNum: 116,
            ruleType,
        },
    });

    const shipToItems = useMemo(() => (data ? mapQBooksContacts(data.Contacts) : []), [data]);

    const handleSearchShipTo = debounce((text: string) => setQuery(text), 500);

    return {
        shipToItems,
        isLoadingShipTo: isLoading,
        handleSearchShipTo,
    };
};

export const useCustomFields = () => {
    const context = useSelector(getContext);
    const request = useSelector<domain.QBooksPoRequest>(getRequest);

    const customFieldsItems = context.fields.filter(
        (field) => field.systemPurpose === domain.FieldSystemPurpose.QBooksCustom
    );

    const customFieldsValues = useMemo(() => {
        return customFieldsItems.reduce<Record<string, string>>((acc, field) => {
            const requestField = request.details.customFields.find(
                (requestField) => requestField.field.id === field.id
            );

            return {
                ...acc,
                [field.id]: requestField?.value || '',
            };
        }, {});
    }, [customFieldsItems, request.details.customFields]);

    return {
        customFieldsItems,
        customFieldsValues,
    };
};
